/**
 * OrderHistory.Item.Actions.View.Extension.js
 *
 * Hides the native "Reorder" button on rental lines in My Account
 * (order detail / rental order detail). A line is a rental line when its
 * columns say so (fast path) or when the order itself is a NetScore rental
 * order (one cached service call per order, shared with the other views).
 */
define("OrderHistory.Item.Actions.View.Extension", [
  "OrderHistory.Item.Actions.View",
  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",
  "Ames.RentFromAnywhere.RentalLine",
  "underscore"
], function (OrderHistoryItemActionsView, RentFromAnywhereSS2Model, RentalLine, _) {
  "use strict";

  // Shared strict rule: custcol_custom_rate / "N Days Rental" / NetScore rate
  // column > 0. Configurable sets (custom price + component list) never match.
  var isRentalLine = RentalLine.isRentalLine;

  _.extend(OrderHistoryItemActionsView.prototype, {
    initialize: _.wrap(OrderHistoryItemActionsView.prototype.initialize, function (fn) {
      fn.apply(this, _.toArray(arguments).slice(1));
      var self = this;
      this.isRentalOrder = false;
      if (!this.model || isRentalLine(this.model)) return;
      var orderId = this.model.id || (this.model.get && this.model.get("order_id"));
      if (!orderId) return;
      RentFromAnywhereSS2Model.orderInfo(orderId).done(function (info) {
        if (!info) return;
        self.isRentalOrder = true;
        if (self.$el && self.$el.length) self.render();
      });
    }),

    getContext: _.wrap(OrderHistoryItemActionsView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      if (this.isRentalOrder || isRentalLine(this.model)) {
        context.showActions = false; // no Reorder for rental units
        context.isRentalLine = true;
      }
      return context;
    })
  });

  return OrderHistoryItemActionsView;
});
